import {
  Box, Typography, CardMedia, Button,
} from '@mui/material';
import React from 'react';
// import image from '../../images/feature2.svg'
import image from '../../images/hero1.svg';

const Home = () => (
  <Box
    id="home"
    sx={{
      maxWidth: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: { xs: 'center', sm: 'space-between' }, alignItems: 'center', padding: { xs: '30px 0', sm: '50px 0' },
    }}
  >
    <Box sx={{ maxWidth: { xs: '100%', sm: '45%' } }}>
      <Typography sx={{
        fontWeight: '500', fontSize: { xs: '30px', sm: '60px' }, lineHeight: { xs: '40px', sm: '60px' }, margin: '10px 0',
      }}
      >
        Convert Audio And Video Files To Text
      </Typography>
      <Typography sx={{ fontWeight: '400', fontSize: { xs: '14px', sm: '20px' }, lineHeight: { xs: '15px', sm: '30px' } }}>We have an enviable reputation for providing highly accurate and bespoke audio & video to text solutions.</Typography>
      <Box sx={{
        display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: '20px', sm: '30px' }, margin: '30px 0',
      }}
      >
        <Button variant="contained" component="a" href="#pricing">Order Now</Button>
        <Button variant="outlined" component="a" href="#services">Learn More</Button>
      </Box>
    </Box>
    <Box sx={{ maxWidth: { xs: '100%', sm: '50%' } }}>
      <CardMedia
        component="img"
        width="60%"
        height="100%"
        image={image}
        alt="hero section"
      />
    </Box>
  </Box>
);

export default Home;
